import React, { useState, useEffect } from "react";
import api from "../utils/api";

const FUNNEL_STEPS = [
  { key: "total_registered", label: "Зарегистрировались" },
  { key: "passed_check", label: "Прошли проверку (шаг 1)" },
  { key: "eligible", label: "Подходят под банкротство (шаг 2)" },
  { key: "paid", label: "Оплатили" },
  { key: "creditors_done", label: "Собрали кредиторов (шаг 3)" },
  { key: "data_filled", label: "Заполнили данные (шаг 6)" },
  { key: "docs_generated", label: "Сгенерировали документы (шаг 7)" },
  { key: "submitted_mfc", label: "Подали в МФЦ (шаг 8)" },
  { key: "completed", label: "Завершили процедуру (шаг 10)" },
];

export default function MfcAnalyticsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/mfc-analytics").then(r => {
      setData(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 32, color: "#8fa0b4" }}>Загрузка...</div>;
  if (!data) return <div style={{ padding: 32, color: "#dc2626" }}>Ошибка загрузки</div>;

  const maxVal = data.total_registered || 1;

  return (
    <div style={{ padding: "24px 32px", maxWidth: 800 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1e2a3a", marginBottom: 24 }}>Аналитика МФЦ-сервиса</h1>

      <div style={card}>
        <h3 style={{ margin: "0 0 20px", fontSize: 16, color: "#334155" }}>Воронка клиентов</h3>
        {FUNNEL_STEPS.map((step, i) => {
          const val = data[step.key] || 0;
          const prev = i > 0 ? (data[FUNNEL_STEPS[i - 1].key] || 1) : maxVal;
          const pct = prev > 0 ? Math.round((val / prev) * 100) : 0;
          const widthPct = maxVal > 0 ? Math.max(4, (val / maxVal) * 100) : 4;
          return (
            <div key={step.key} style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}>
                <span style={{ color: "#334155" }}>{step.label}</span>
                <span style={{ color: "#64748b" }}>
                  <b>{val}</b>
                  {i > 0 && <span style={{ marginLeft: 8, color: pct >= 50 ? "#16a34a" : pct >= 20 ? "#ca8a04" : "#dc2626" }}>({pct}%)</span>}
                </span>
              </div>
              <div style={{ background: "#f1f5f9", borderRadius: 6, height: 24, overflow: "hidden" }}>
                <div style={{ width: widthPct + "%", height: "100%", background: barColor(i), borderRadius: 6, transition: "width 0.5s" }} />
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
        <div style={statCard}>
          <div style={statNum}>{data.active_contracts || 0}</div>
          <div style={statLabel}>Активных договоров</div>
        </div>
        <div style={statCard}>
          <div style={statNum}>{data.accepted_contracts || 0}</div>
          <div style={statLabel}>Принятых оферт</div>
        </div>
        <div style={statCard}>
          <div style={statNum}>{data.paid || 0}</div>
          <div style={statLabel}>Оплатили сервис</div>
        </div>
      </div>
    </div>
  );
}

function barColor(i) {
  const colors = ["#4f6ef7", "#6366f1", "#8b5cf6", "#a855f7", "#d946ef", "#ec4899", "#f43f5e", "#ef4444", "#16a34a"];
  return colors[i] || "#4f6ef7";
}

const card = { background: "#fff", borderRadius: 12, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" };
const statCard = { flex: 1, background: "#fff", borderRadius: 12, padding: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", textAlign: "center" };
const statNum = { fontSize: 28, fontWeight: 700, color: "#1e293b" };
const statLabel = { fontSize: 13, color: "#64748b", marginTop: 4 };
